/* eslint-disable */
require('./arrow-right')
require('./bell')
require('./bike')
require('./bus')
require('./calendar')
require('./car')
require('./chat')
require('./check')
require('./clock')
require('./cross')
require('./delete')
require('./download')
require('./driving-license')
require('./enter')
require('./envelope')
require('./exit')
require('./eye')
require('./invoice')
require('./magnifying-glass')
require('./menu')
require('./nagora-mission-a-domicile')
require('./nagora-n-cercle')
require('./nagora-n')
require('./phone')
require('./pin')
require('./plus')
require('./question-mark')
require('./scooter')
require('./three-buildings')
require('./user')
require('./va')
require('./vitalliance')
require('./search')
require('./group')
require('./file')
require('./envelope-open');
